import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsBoxArrowInUpRight } from 'react-icons/bs';
import { TabContent, TabPane } from 'reactstrap';
import CustomTabs from 'components/CustomTabs';
import { LISTING_TABS } from 'pages/Dashboard/components/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import PermissionNotice from 'pages/Dashboard/components/PermissionNotice';
import NewOffers from './components/NewOffers';
import NewDemands from './components/NewDemands';

const Listings = ({ canView = true }) => {
  const [activeTab, setActiveTab] = useState(LISTING_TABS.NEW_OFFERS);
  const navigate = useNavigate();
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (!canView) {
    return (
      <div className="py-3">
        <PermissionNotice message="You do not have permission to view Listings." />
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[LISTING_TABS.NEW_OFFERS, LISTING_TABS.NEW_DEMANDS]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="border-0 inner-list-tab"
        />
        <div
          aria-hidden="true"
          className="view-all-btn ms-auto text-decoration-none text-nowrap"
          onClick={() => navigate('/market-listing')}
        >
          View All <BsBoxArrowInUpRight />
        </div>
      </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={LISTING_TABS.NEW_OFFERS}>
          {activeTab === LISTING_TABS.NEW_OFFERS && (
            <ErrorBoundary>
              <NewOffers />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={LISTING_TABS.NEW_DEMANDS}>
          {activeTab === LISTING_TABS.NEW_DEMANDS && (
            <ErrorBoundary>
              <NewDemands />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default Listings;
